// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperImport = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    width: 100%;
    padding: 26px 34px 35px;
    background-color: ${isDark ? theme.colors.base.main : theme.colors.white};
    box-shadow: ${
      isDark
        ? 'none'
        : '0px 0px 16px rgba(195, 203, 214, 0.16), 0px 1px 4px rgba(195, 203, 214, 0.16)'
    };
    border-radius: 16px;
    margin-bottom: 100px;

    ${theme.breakpoints.down('sm')} {
      padding: 16px;
    }
  `,
);

export const Divider = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    margin: 20px -34px 28px -34px;

    ${theme.breakpoints.down('sm')} {
      margin: 20px -16px 28px -16px;
    }
  `,
);

export const FileHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const TableWrapper = styled.table<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    width: 100%;
    border-collapse: collapse;
    text-align: left;

    thead {
      display: table;
      width: calc(100% - 10px);
      background-color: ${theme.colors.base['lighter-16']};
      border-radius: 32px;
      table-layout: fixed;

      tr {
        th {
          text-overflow: ellipsis;
          overflow: hidden;
          padding: 12px;
          white-space: nowrap;
          :first-child {
            padding-left: 30px;
          }
        }
      }
    }

    tbody {
      display: block;
      height: 300px;
      overflow: auto;
      tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-bottom: 1px solid ${theme.colors.gray['dark-24']};

        :last-child {
          border-bottom: none;
        }

        :hover {
          background-color: ${
            isDark
              ? theme.colors.base['light-dark-mode']
              : theme.colors.gray.lighter
          };
        }

        td {
          text-overflow: ellipsis;
          overflow: hidden;
          color: ${isDark ? theme.colors.white : theme.colors.base.dark};
          padding: 20px 12px 12px;

          :first-child {
            padding-left: 30px;
          }
        }
      }
    }
  `,
);

export const Notification = styled.span<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    padding: 2px 7px;
    background-color: ${
      isDark ? theme.colors.gray['lighter-dark-mode'] : theme.colors.gray.light
    };
    color: ${isDark ? theme.colors.white : theme.colors.base.main};
    border-radius: 5px;
  `,
);

export const StatusWrapper = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    margin-top: 20px;
    height: 280px;
    color: ${isDark ? theme.colors.white : theme.colors.gray.dark};
    background-color: ${
      isDark
        ? theme.colors.base['lighter-dark-mode']
        : theme.colors.gray.lighter
    };
    gap: 17px;
  `,
);
